import * as services from 'services/catalogos.service';
import * as types from 'constants/publicDownloadsActionTypes';

export const getProcesosPublico =
  (data, updateState = true) =>
  async (dispatch) => {
    if (updateState) {
      dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
    }
    try {
      const response = await services.fetchCatProcesosPublico(data);
      if (updateState) {
        dispatch({
          type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
          success: true,
          response: response.data
        });
      }
      return { success: true, response: response.data };
    } catch (error) {
      if (updateState) {
        dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
      }
      return { success: false };
    }
  };

export const getFiltrosPublico =
  (data, updateState = true) =>
  async (dispatch) => {
    if (updateState) {
      dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
    }
    try {
      const response = await services.fetchCatsFiltrosPublico(data);
      if (updateState) {
        dispatch({
          type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
          success: true,
          response: response.data
        });
      }
      return { success: true, response: response.data };
    } catch (error) {
      if (updateState) {
        dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
      }
      return { success: false };
    }
  };

export const getEntidadesPublico =
  (data, updateState = true) =>
  async (dispatch) => {
    if (updateState) {
      dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
    }
    try {
      const response = await services.fetchCatEstadosPublico(data);
      if (updateState) {
        dispatch({
          type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
          success: true,
          response: response.data
        });
      }
      return { success: true, response: response.data };
    } catch (error) {
      if (updateState) {
        dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
      }
      return { success: false };
    }
  };

export const getBeneficiadosPublico =
  (data, updateState = true) =>
  async (dispatch) => {
    if (updateState) {
      dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
    }
    try {
      const response = await services.fetchCatBeneficiadosPublico(data);
      if (updateState) {
        dispatch({
          type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
          success: true,
          response: response.data
        });
      }
      return { success: true, response: response.data };
    } catch (error) {
      if (updateState) {
        dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
      }
      return { success: false };
    }
  };

export const getTiposMonitoreo =
  (data, updateState = true) =>
  async (dispatch) => {
    if (updateState) {
      dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
    }
    try {
      const response = await services.fetchCatTiposMonitoreo(data);
      if (updateState) {
        dispatch({
          type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
          success: true,
          response: response.data
        });
      }
      return { success: true, response: response.data };
    } catch (error) {
      if (updateState) {
        dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
      }
      return { success: false };
    }
  };

export const getTiposHallazgo =
  (data, updateState = true) =>
  async (dispatch) => {
    if (updateState) {
      dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
    }
    try {
      const response = await services.fetchCatTiposHallazgo(data);
      if (updateState) {
        dispatch({
          type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
          success: true,
          response: response.data
        });
      }
      return { success: true, response: response.data };
    } catch (error) {
      if (updateState) {
        dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
      }
      return { success: false };
    }
  };

// export const getPublicDownloadsCatalogs =
//   (data, updateState = true) =>
//   async (dispatch) => {
//     if (updateState) {
//       dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
//     }
//     try {
//       const response = await services.fetchPublicDownloadsCatalogs(data);
//       if (updateState) {
//         dispatch({
//           type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
//           success: true,
//           response: response.data
//         });
//       }
//       return { success: true, response };
//     } catch (error) {
//       if (updateState) {
//         dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
//       }
//       return { success: false };
//     }
//   };

export const getPublicDownloads =
  (data, updateState = true) =>
  async (dispatch) => {
    if (updateState) {
      dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
    }
    try {
      const response = await services.fetchPublicDownloads(data);
      if (updateState) {
        dispatch({
          type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
          success: true,
          response: response.data.consulta
        });
      }
      return { success: true, response };
    } catch (error) {
      if (updateState) {
        dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
      }
      return { success: false };
    }
  };

export const clearPublicDownloads = () => async (dispatch) => {
  dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_LOADING });
  try {
    dispatch({
      type: types.GET_LIST_PUBLIC_DOWNLOADS_SUCCESS,
      success: true,
      response: []
    });
    return { success: true, response: [] };
  } catch (error) {
    dispatch({ type: types.GET_LIST_PUBLIC_DOWNLOADS_FAILURE, error });
    return { success: false };
  }
};
